import React, { createContext, useContext, ReactNode } from 'react';
import { ProfileData, defaultProfile } from '../firebase/profileService';
import { useProfileQuery } from '../hooks/useProfileQuery';

interface ProfileContextType {
  profile: ProfileData;
  loading: boolean;
  error: Error | null;
  refreshProfile: () => void;
}

const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

export const ProfileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data, isLoading, error, refetch } = useProfileQuery();
  
  const profile = data ?? defaultProfile;
  
  return (
    <ProfileContext.Provider 
      value={{ 
        profile, 
        loading: isLoading, 
        error: error as Error | null, 
        refreshProfile: refetch 
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = (): ProfileContextType => {
  const context = useContext(ProfileContext);
  if (context === undefined) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
}; 